import React from 'react'
import { TopicHeader } from '@christies/react/components/Headers'
import { withParsedContext } from '../../withJSSContext'

interface Props {
  parsedRouteFields: {
    Title: string
    'Secondary Title': string
    'Screen Reader Title': string
  }
}

const MagazinesArchiveHeaderModule: React.FC<Props> = (props) => {
  const { parsedRouteFields } = props

  return (
    <TopicHeader
      title={parsedRouteFields?.['Title']}
      secondaryTitle={parsedRouteFields?.['Secondary Title']}
      accessibilityTitle={parsedRouteFields?.['Screen Reader Title']}
    />
  )
}

export default withParsedContext(MagazinesArchiveHeaderModule as React.FC)
